import styled, { css } from 'styled-components';
import { Button as ButtonComponent } from 'components/Button';
import { NftMedia } from 'components/Shared/NftMedia';
import { isMobile } from 'utils';

export const NftCardMedia = styled(NftMedia)`
  grid-column-start: 1;
  grid-column-end: 13;
`;

export const NftCardMediaSkeleton = styled.div`
  grid-column-start: 1;
  grid-column-end: 13;
  overflow: hidden;
`;

export const NftCardName = styled.div`
  color: var(--v3-black-100);
  font-weight: ${isMobile() ? '500' : '600'};
  font-size: ${isMobile() ? '15px' : '18px'};
  line-height: ${isMobile() ? '20px' : '22px'};
  grid-column-start: 1;
  grid-column-end: 13;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
`;

export const NftCardPrice = styled.div`
  grid-column-start: 1;
  grid-column-end: 13;
  grid-row-start: 7;
  line-height: ${isMobile() ? '20px' : '22px'};
  font-size: ${isMobile() ? '14px' : '16px'};
  font-weight: ${isMobile() ? '600' : '500'};
  color: var(--v3-primary-color);
`;

export const Button = styled(ButtonComponent)`
  &&&& {
    font-weight: 500;
    border-radius: 12px;
    line-height: 20px;
    font-size: ${isMobile() ? '14px' : '16px'};
    padding: 11px 22px;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
`;

export const NftCardInfoWrapper = styled.div`
  grid-column-start: 1;
  grid-column-end: 13;
  grid-row-start: 3;
  display: grid;
  gap: 10px;
  padding: 12px;
  border-radius: 18px;
  background: var(--v3-black-0);
`;

export const DetailsWrapper = styled.div`
  display: grid;
  grid-template-rows: auto 6px auto;
`;

export const NftCardWrapper = styled.div<{
  $flexible: boolean;
}>`
  display: grid;
  grid-template-columns: repeat(12, auto);
  border: 1px solid var(--v3-black-2);
  height: fit-content;
  border-radius: 24px;
  padding: 12px;
  background: var(--v3-black-4);
  cursor: pointer;
  ${props =>
    props.$flexible &&
    css`
      width: 100%;
    `}
`;
